import Container from "react-bootstrap/Container";
import CompanyLogo1 from "../../assets/logos_parceiros/regina.png";
import CompanyLogo2 from "../../assets/logos_parceiros/panvel.png";
import CompanyLogo3 from "../../assets/logos_parceiros/centroeco.png";
import CompanyLogo4 from "../../assets/logos_parceiros/nap.png";
import CompanyLogo5 from "../../assets/logos_parceiros/emporio-gaia.png";
import CompanyLogo6 from "../../assets/logos_parceiros/exame.png";
import CompanyLogo7 from "../../assets/logos_parceiros/unimed.png";
import CompanyLogo8 from "../../assets/logos_parceiros/droga-raia.png";
import CompanyLogo9 from "../../assets/logos_parceiros/doctor-med.png";
import CompanyLogo10 from "../../assets/logos_parceiros/formula-bichos.png";
import CompanyLogo11 from "../../assets/logos_parceiros/adaptta.png";
import CompanyLogo12 from "../../assets/logos_parceiros/cfisio.png";
import CompanyLogo13 from "../../assets/logos_parceiros/hemovida.png";
import CompanyLogo14 from "../../assets/logos_parceiros/proscout.png";
import CompanyLogo15 from "../../assets/logos_parceiros/pet-store.png";
import CompanyLogo16 from "../../assets/logos_parceiros/fisiohaus.png";
import CompanyLogo17 from "../../assets/logos_parceiros/hospital-sapiranga.png";
import CompanyLogo18 from "../../assets/logos_parceiros/instituto-visao.png";
import CompanyLogo19 from "../../assets/logos_parceiros/nao-mais-pelo.png";
import CompanyLogo20 from "../../assets/logos_parceiros/oticas-carol.png";
import CompanyLogo21 from "../../assets/logos_parceiros/laboratorio-bio.png";
import CompanyLogo22 from "../../assets/logos_parceiros/maxxi-odonto.png";
import CompanyLogo23 from "../../assets/logos_parceiros/ponto-psi.png";
import CompanyLogo24 from "../../assets/logos_parceiros/qualita.png";
import CompanyLogo25 from "../../assets/logos_parceiros/uptime.png";
import CompanyLogo26 from "../../assets/logos_parceiros/sant.png";
import CompanyLogo27 from "../../assets/logos_parceiros/oticas-pisquey.png";
import CompanyLogo28 from "../../assets/logos_parceiros/servdonto.png";
import CompanyLogo29 from "../../assets/logos_parceiros/sos-kids.png";
import CompanyLogo30 from "../../assets/logos_parceiros/vida-e-saude.png";
import CompanyLogo31 from "../../assets/logos_parceiros/saintmichel.png";
import CompanyLogo32 from "../../assets/logos_parceiros/strapacao.png";
import CompanyLogo33 from "../../assets/logos_parceiros/upa-vet.png";
import CompanyLogo34 from "../../assets/logos_parceiros/vic-center.png";
import CompanyLogo35 from "../../assets/logos_parceiros/cia-do-corpo.png";
import CompanyLogo36 from "../../assets/logos_parceiros/sao-jose.png";
import CompanyLogo37 from "../../assets/logos_parceiros/matriz.png";
import CompanyLogo38 from "../../assets/logos_parceiros/fleming.png";
import CompanyLogo39 from "../../assets/logos_parceiros/tecnolar.png";
import CompanyLogo40 from "../../assets/logos_parceiros/intensidade.png";
import CompanyLogo41 from "../../assets/logos_parceiros/weinmann.png";
import CompanyLogo42 from "../../assets/logos_parceiros/serdil.png";
import CompanyLogo43 from "../../assets/logos_parceiros/oticas-corujinha.png";
import CompanyLogo44 from "../../assets/logos_parceiros/clinica-visao.png";
import CompanyLogo45 from "../../assets/logos_parceiros/uniao-pet-center.png";
import "./AutoPlayCarousel.css";

import Carousel from "react-multi-carousel";

export default function AutoPlayCarousel() {
  const responsive = {
    wide: {
      breakpoint: { max: 4000, min: 1501 },
      items: 8,
      slidesToSlide: 1,
    },
    desktop: {
      breakpoint: { max: 1500, min: 1201 },
      items: 6,
      slidesToSlide: 1,
    },
    tablet: {
      breakpoint: { max: 1200, min: 701 },
      items: 4,
      slidesToSlide: 1,
    },
    mobile: {
      breakpoint: { max: 700, min: 0 },
      items: 2,
      slidesToSlide: 1,
    },
  };

  const brandLogosCards = [
    {
      id: 1,
      imgUrl: CompanyLogo1,
      title: "Hospital Regina",
    },
    {
      id: 2,
      imgUrl: CompanyLogo2,
      title: "Panvel",
    },
    {
      id: 3,
      imgUrl: CompanyLogo3,
      title: "Centro Eco",
    },

    {
      id: 4,
      imgUrl: CompanyLogo4,
      title: "NAP",
    },
    {
      id: 5,
      imgUrl: CompanyLogo5,
      title: "Emporio Gaia",
    },
    {
      id: 6,
      imgUrl: CompanyLogo6,
      title: "Exame",
    },
    {
      id: 7,
      imgUrl: CompanyLogo7,
      title: "Unimed",
    },
    {
      id: 8,
      imgUrl: CompanyLogo8,
      title: "Droga Raia",
    },
    {
      id: 9,
      imgUrl: CompanyLogo9,
      title: "Doctor Med",
    },
    {
      id: 10,
      imgUrl: CompanyLogo10,
      title: "Fórmula Bichos",
    },
    {
      id: 11,
      imgUrl: CompanyLogo11,
      title: "Pet Store",
    },
    {
      id: 12,
      imgUrl: CompanyLogo12,
      title: "Adaptta",
    },
    {
      id: 13,
      imgUrl: CompanyLogo13,
      title: "Cfisio",
    },
    {
      id: 14,
      imgUrl: CompanyLogo14,
      title: "Hemovida",
    },
    {
      id: 15,
      imgUrl: CompanyLogo15,
      title: "Proscout",
    },
    {
      id: 16,
      imgUrl: CompanyLogo16,
      title: "Fisiohaus",
    },
    {
      id: 17,
      imgUrl: CompanyLogo17,
      title: "Hospital Sapiranga",
    },
    {
      id: 18,
      imgUrl: CompanyLogo18,
      title: "Instituto Visão",
    },
    {
      id: 19,
      imgUrl: CompanyLogo19,
      title: "Não + Pelo",
    },
    {
      id: 20,
      imgUrl: CompanyLogo20,
      title: "Óticas Carol",
    },
    {
      id: 21,
      imgUrl: CompanyLogo21,
      title: "Laboratório Bio",
    },
    {
      id: 22,
      imgUrl: CompanyLogo22,
      title: "Maxxi Odonto",
    },
    {
      id: 23,
      imgUrl: CompanyLogo23,
      title: "Ponto Psi",
    },
    {
      id: 24,
      imgUrl: CompanyLogo24,
      title: "Qualitá",
    },
    {
      id: 25,
      imgUrl: CompanyLogo25,
      title: "Uptime",
    },
    {
      id: 26,
      imgUrl: CompanyLogo26,
      title: "Sant",
    },
    {
      id: 27,
      imgUrl: CompanyLogo27,
      title: "Oticas Pisquey",
    },
    {
      id: 28,
      imgUrl: CompanyLogo28,
      title: "Servdonto",
    },
    {
      id: 29,
      imgUrl: CompanyLogo29,
      title: "SOS Kids",
    },
    {
      id: 30,
      imgUrl: CompanyLogo30,
      title: "Serdil",
    },
    {
      id: 31,
      imgUrl: CompanyLogo31,
      title: "Saint Michel",
    },
    {
      id: 32,
      imgUrl: CompanyLogo32,
      title: "Strapação",
    },
    {
      id: 33,
      imgUrl: CompanyLogo33,
      title: "UPA Vet",
    },
    {
      id: 34,
      imgUrl: CompanyLogo34,
      title: "Vic Center",
    },
    {
      id: 35,
      imgUrl: CompanyLogo35,
      title: "Cia do Corpo",
    },
    {
      id: 36,
      imgUrl: CompanyLogo36,
      title: "São José",
    },
    {
      id: 37,
      imgUrl: CompanyLogo37,
      title: "Matriz",
    },
    {
      id: 38,
      imgUrl: CompanyLogo38,
      title: "Fleming",
    },
    {
      id: 39,
      imgUrl: CompanyLogo39,
      title: "Tecnolar",
    },
    {
      id: 40,
      imgUrl: CompanyLogo40,
      title: "Intensidade",
    },
    {
      id: 41,
      imgUrl: CompanyLogo41,
      title: "Weinmann",
    },
    {
      id: 42,
      imgUrl: CompanyLogo42,
      title: "Serdil",
    },
    {
      id: 43,
      imgUrl: CompanyLogo43,
      title: "Corujinha",
    },
    {
      id: 44,
      imgUrl: CompanyLogo44,
      title: "Clínica Visão",
    },
    {
      id: 45,
      imgUrl: CompanyLogo45,
      title: "União Pet Center",
    },
  ];

  return (
    <Container fluid className="autoplay-carousel-wrapper">
      <div className="autoplay-carousel-container-overlay " />
      <Carousel
        containerClass="autoplay-carousel-container"
        showDots={false}
        swipeable={false}
        draggable={false}
        responsive={responsive}
        infinite={true}
        removeArrowOnDeviceType={["wide", "desktop", "tablet", "mobile"]}
        autoPlay={true}
        autoPlaySpeed={1300}
        transitionDuration={500}
        keyBoardControl={false}
      >
        {brandLogosCards.map((card) => (
          <div key={card.id} className="autoplay-carousel-card">
            <img src={card.imgUrl} alt={card.title} />
          </div>
        ))}
      </Carousel>
    </Container>
  );
}
